import React from 'react';
import { IntlForm } from 'react-ocean-forms-react-intl';
import { useComponentsContext } from '../ParamComponents';
import { useQuery } from '@apollo/client';
import { BasePreviewModalProps, PreviewModal } from '../Common/Modals';
import { ComponentGraphQLService } from '../../graphql';
import { ComponentService } from '../../api';
import { ComponentNewEditForm } from '../../views/Component/ComponentNewEdit/ComponentNewEditForm';
import { readView } from '../../views/Component/ComponentNewEdit/viewConfig';

/**
 * reload data
 * element, type  viewconfig, 
 */
export interface ComponentPreviewModalProps extends BasePreviewModalProps {
  element: any;
}

export const ComponentPreviewModal: React.FC<ComponentPreviewModalProps> = ({ 
  open, setOpen,
  element,
  headerId, headerValues = undefined }): JSX.Element | null => {

  const { componentType } = useComponentsContext();
  console.log('preview modal', element);

  // load data with ID 
  const {data, loading, error } = useQuery(
    ComponentGraphQLService.getComponent(componentType),
    { fetchPolicy: 'network-only',
      variables: { id: element.id }
    }
  )

  let formData = {};
  let status = undefined;
  if(data && componentType) {
    formData = ComponentService.transformDtoToForm(componentType, data[Object.keys(data)[0]]);
    status = data[Object.keys(data)[0]]?.status;
  }
  

  
  return (
    <PreviewModal
      open={open} setOpen={setOpen}
      headerId={headerId}
      headerValues={headerValues}
    >
      <IntlForm
        values={formData}
      >
        <ComponentNewEditForm
          viewConfig={readView}
          componentStatus={status}
        />
      </IntlForm>
    </PreviewModal>
  );

}
